import {
  ArtifactTypeEnum,
  GameModelArtifactFileTypeEnum,
  GameModelStateFileTypeEnum,
} from "../../../generated/graphql";
import { BundleNames } from "../../MobileAppModal/MobileAppModelModal/constants";
import { ArtifactsNameEnum, ArtifactsNameKeyEnum } from "./types";

export const BundleTypesMap = new Map<BundleNames, GameModelStateFileTypeEnum>([
  [BundleNames.Ios, GameModelStateFileTypeEnum.IosBundle],
  [BundleNames.IosOptimized, GameModelStateFileTypeEnum.IosBundleOptimized],
  [BundleNames.Android, GameModelStateFileTypeEnum.AndroidBundle],
  [
    BundleNames.AndroidOptimized,
    GameModelStateFileTypeEnum.AndroidBundleOptimized,
  ],
  [BundleNames.IosManifest, GameModelStateFileTypeEnum.IosManifest],
  [
    BundleNames.IosOptimizedManifest,
    GameModelStateFileTypeEnum.IosManifestOptimized,
  ],
  [BundleNames.AndroidManifest, GameModelStateFileTypeEnum.AndroidManifest],
  [
    BundleNames.AndroidOptimizedManifest,
    GameModelStateFileTypeEnum.AndroidManifestOptimized,
  ],
  [BundleNames.WebGL, GameModelStateFileTypeEnum.WebGlBundle],
  [BundleNames.WebGlManifest, GameModelStateFileTypeEnum.WebGlManifest],
  [BundleNames.WebGlOptimized, GameModelStateFileTypeEnum.WebGlBundleOptimized],
  [
    BundleNames.WebGlOptimizedManifest,
    GameModelStateFileTypeEnum.WebGlManifestOptimized,
  ],
]);

export const ArtifactNamesMap = new Map<ArtifactsNameEnum, ArtifactTypeEnum>([
  [ArtifactsNameEnum.Head, ArtifactTypeEnum.Cloth],
  [ArtifactsNameEnum.Body, ArtifactTypeEnum.Cloth],
  [ArtifactsNameEnum.Legs, ArtifactTypeEnum.Cloth],
  [ArtifactsNameEnum.Things, ArtifactTypeEnum.Good],
  [ArtifactsNameEnum.Animations, ArtifactTypeEnum.Animation],
]);

export const ArtifactNamesKeysMap = new Map<
  ArtifactsNameEnum,
  ArtifactsNameKeyEnum
>([
  [ArtifactsNameEnum.Head, ArtifactsNameKeyEnum.Head],
  [ArtifactsNameEnum.Body, ArtifactsNameKeyEnum.Body],
  [ArtifactsNameEnum.Legs, ArtifactsNameKeyEnum.Legs],
  [ArtifactsNameEnum.Things, ArtifactsNameKeyEnum.Things],
  [ArtifactsNameEnum.Animations, ArtifactsNameKeyEnum.Animations],
]);

export const ArtifactModelTitles = new Map<ArtifactTypeEnum, string>([
  [ArtifactTypeEnum.Cloth, "одягу"],
  [ArtifactTypeEnum.Good, "предмета"],
  [ArtifactTypeEnum.Animation, "анімації"],
]);

export const ArtifactBundleTypesMap = new Map<
  BundleNames,
  GameModelArtifactFileTypeEnum
>([
  [BundleNames.Ios, GameModelArtifactFileTypeEnum.IosBundle],
  [BundleNames.IosOptimized, GameModelArtifactFileTypeEnum.IosBundleOptimized],
  [BundleNames.Android, GameModelArtifactFileTypeEnum.AndroidBundle],
  [
    BundleNames.AndroidOptimized,
    GameModelArtifactFileTypeEnum.AndroidBundleOptimized,
  ],
  [BundleNames.IosManifest, GameModelArtifactFileTypeEnum.IosManifest],
  [
    BundleNames.IosOptimizedManifest,
    GameModelArtifactFileTypeEnum.IosManifestOptimized,
  ],
  [BundleNames.AndroidManifest, GameModelArtifactFileTypeEnum.AndroidManifest],
  [
    BundleNames.AndroidOptimizedManifest,
    GameModelArtifactFileTypeEnum.AndroidManifestOptimized,
  ],
  [
    BundleNames.WebGlBundleClothesObjects,
    GameModelArtifactFileTypeEnum.WebGlBundle,
  ],
  [
    BundleNames.WebGlOptimizedBundleClothesObjects,
    GameModelArtifactFileTypeEnum.WebGlBundleOptimized,
  ],
  [
    BundleNames.WebGlManifestClothesObjects,
    GameModelArtifactFileTypeEnum.WebGlManifest,
  ],
  [
    BundleNames.WebGlOptimizedManifestClothesObjects,
    GameModelArtifactFileTypeEnum.WebGlManifestOptimized,
  ],
]);
